import { sharedStrings } from "@shared/i18n/sharedStrings";
import { componentStrings } from "@src/i18n/components";

export const strings = {
  shared: sharedStrings,
  components: componentStrings,
} as const;
